
      var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgAccessible = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 25,
  viewBox: "0 0 24 25",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("mask", {
  id: "accessible_a75cf736deae277c__a",
  style: {
    maskType: "alpha"
  },
  maskUnits: "userSpaceOnUse",
  x: 0,
  y: 0,
  width: 24,
  height: 25
}, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#D9D9D9",
  d: "M0 .971h24v24H0z"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  mask: "url(#accessible_a75cf736deae277c__a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M12.048 7.105c-.505 0-.94-.182-1.302-.545a1.777 1.777 0 0 1-.544-1.302c0-.505.181-.939.544-1.302a1.777 1.777 0 0 1 1.302-.544c.505 0 .939.182 1.302.544.362.363.544.797.544 1.302 0 .506-.182.94-.544 1.302a1.777 1.777 0 0 1-1.302.545zm5.115 15.634v-4.77a.247.247 0 0 0-.067-.182.247.247 0 0 0-.183-.067h-4.846a1.71 1.71 0 0 1-1.25-.52 1.703 1.703 0 0 1-.52-1.25V9.97c0-.486.17-.9.511-1.24.34-.34.754-.51 1.24-.51a1.7 1.7 0 0 1 .869.229c.263.152.558.417.885.794.923 1.093 1.74 1.843 2.453 2.248.713.405 1.535.642 2.466.71v1.5a6.907 6.907 0 0 1-2.651-.686 9.205 9.205 0 0 1-2.35-1.65v4.432h3.174c.486 0 .902.173 1.249.52.347.347.52.763.52 1.25v5.172h-1.5zm-7.115 0c-1.313 0-2.436-.467-3.37-1.4-.933-.933-1.4-2.056-1.4-3.37 0-1.18.38-2.21 1.138-3.088.758-.878 1.719-1.414 2.882-1.61v1.532a3.345 3.345 0 0 0-1.803 1.136c-.478.576-.717 1.253-.717 2.03 0 .911.318 1.684.952 2.318.635.635 1.407.952 2.318.952.778 0 1.455-.239 2.03-.716a3.348 3.348 0 0 0 1.137-1.803h1.53a4.647 4.647 0 0 1-1.6 2.872c-.884.765-1.917 1.147-3.097 1.147z",
  fill: "#1C1B1F"
}))));

      const __svgRaw = "<svg width=\"24\" height=\"25\" viewBox=\"0 0 24 25\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\r\n    <mask id=\"31rsrb3b2a\" style=\"mask-type:alpha\" maskUnits=\"userSpaceOnUse\" x=\"0\" y=\"0\" width=\"24\" height=\"25\">\r\n        <path fill=\"#D9D9D9\" d=\"M0 .971h24v24H0z\"/>\r\n    </mask>\r\n    <g mask=\"url(#31rsrb3b2a)\">\r\n        <path d=\"M12.048 7.105c-.505 0-.94-.182-1.302-.545a1.777 1.777 0 0 1-.544-1.302c0-.505.181-.939.544-1.302a1.777 1.777 0 0 1 1.302-.544c.505 0 .939.182 1.302.544.362.363.544.797.544 1.302 0 .506-.182.94-.544 1.302a1.777 1.777 0 0 1-1.302.545zm5.115 15.634v-4.77a.247.247 0 0 0-.067-.182.247.247 0 0 0-.183-.067h-4.846c-.486 0-.902-.174-1.25-.52a1.703 1.703 0 0 1-.52-1.25V9.97c0-.486.17-.9.511-1.24.34-.34.754-.51 1.24-.51a1.7 1.7 0 0 1 .869.229c.263.152.558.417.885.794.923 1.093 1.74 1.843 2.453 2.248.713.405 1.535.642 2.466.71v1.5a6.907 6.907 0 0 1-2.651-.686 9.205 9.205 0 0 1-2.35-1.65v4.432h3.174c.486 0 .902.173 1.249.52.347.347.52.763.52 1.25v5.172h-1.5zm-7.115 0c-1.313 0-2.436-.467-3.37-1.4-.933-.933-1.4-2.056-1.4-3.37 0-1.18.38-2.21 1.138-3.088.758-.878 1.719-1.414 2.882-1.61v1.532a3.345 3.345 0 0 0-1.803 1.136c-.478.576-.717 1.253-.717 2.03 0 .911.318 1.684.952 2.318.635.635 1.407.952 2.318.952.778 0 1.455-.239 2.03-.716a3.348 3.348 0 0 0 1.137-1.803h1.53a4.647 4.647 0 0 1-1.6 2.872c-.884.765-1.917 1.147-3.097 1.147z\" fill=\"#1C1B1F\"/>\r\n    </g>\r\n</svg>\r\n";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/accessible.a75cf736deae277c76fb1b3c07822766.svg"),
        {
          React: SvgAccessible,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      